import React from "react"
import "./index.css"
import avatar from "../../assets/default.png"

const Guild = (props) => (
  <div className={"guild"}>
    <img
      src={
        props.guild.icon
          ? `https://cdn.discordapp.com/icons/${props.guild.id}/${props.guild.icon}.png`
          : avatar
      }
      alt={"icon"}
    />
    <div className={"guild-content"}>
      <p className={"name"}>{props.guild.name}</p>
    </div>
  </div>
)

export default Guild



// WEBPACK FOOTER //
// ./src/components/guild/Guild.js